'use client';

import { useEffect } from 'react';
import { OwApp } from '../interfaces/domain/ow-app.modal';
import { dispatch } from '../hooks/use-bus';
import { AppBusEventType } from '../interfaces/bus-events';
import { setCurrentAppIdCache } from '../hooks/use-current-app-id';
import AppPageContext from './app-page-context';

interface Props {
  children: React.ReactNode;
  app: OwApp;
}

// -----------------------------------------------------------------------------
const AppPageContextProvider = (props: Props): JSX.Element => {
  const { app, children } = props;

  useEffect(() => {
    const appId = app?.id ?? null;
    setCurrentAppIdCache(appId);
    dispatch({
      type: AppBusEventType.App.CurrentAppChanged,
      data: { appId },
    });

    return () => {
      setCurrentAppIdCache(null);
      dispatch({
        type: AppBusEventType.App.CurrentAppChanged,
        data: { appId: null },
      });
    };
  }, [app?.id]);

  return (
    <AppPageContext.Provider value={{ app }}>
      {children}
    </AppPageContext.Provider>
  );
};

export default AppPageContextProvider;
